import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { _isUserNameAndLastName, AuthService } from 'app/services/auth.service';
import { AssignmentMovementService } from 'app/services/models/assignment-movement.service';
import { EquipmentService } from 'app/services/models/equipment.service';
import { PersonService } from 'app/services/models/person.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-assignment-movement-dialog',
  templateUrl: './assignment-movement-dialog.component.html',
  styleUrls: ['./assignment-movement-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssignmentMovementDialogComponent implements OnInit {
  @Input() data: { id?: number, equipmentId; };
  fromPersonList: any[] = [];
  toPersonList: any[] = [];
  date: Date = new Date();
  equipment: any = {};
  assignmentMovementData: any = {};
  assignmentMovement: FormGroup;
  isPersonId: number;

  constructor(
    public activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    private personService: PersonService,
    private assignmetnService: AssignmentMovementService,
    public authService: AuthService,
    private equipmentService: EquipmentService,
  ) {
    this.isPersonId = this.authService.isPersonId; // ALINDI

  }

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  async ngOnInit() {
    this.assignmentMovement = this.fb.group({
      fromPersonId: [null, Validators.required],
      toPersonId: [null, Validators.required],
      movementType: [null, Validators.required],
      movementDate: [true, Validators.required],
      description: [null],
      equipmentId: [null, Validators.required],
    });
    if (this.data.equipmentId) {
      this.assignmentMovement.patchValue({
        equipmentId: this.data.equipmentId
      });
    }
    await this.getFromPersonList('');
    await this.getToPersonList('');
    if (this.data.id) {
      await this.getByIdAssignmentMovement(this.data.id);
    }
    if (this.data.equipmentId) {
      await this.asyncGetByIdEquipment(this.data.equipmentId);
    }
    this.assignmentMovement.get('movementType').valueChanges.subscribe((value) => {
      this.setPersonDefaults(value);
    });
  }

  async asyncGetByIdEquipment(id) {
    const data = await this.equipmentService.getByIdEquipment(id);
    console.log(data);
    this.equipment = data;
    if (data.lastMovement != null) {
      const lastMovement = data.lastMovement;
      if (lastMovement.toPersonId != null) {
        this.assignmentMovement.patchValue({
          fromPersonId: lastMovement.toPersonId,
          movementType: 1,
          toPersonId: this.isPersonId
        });
      }
    }
  }

  async getByIdAssignmentMovement(id) {
    const data = await this.assignmetnService.getByIdAssignment(id);
    console.log(data);
    this.assignmentMovementData = data;
    this.date = new Date(data.movementDate);
    this.assignmentMovement.patchValue({
      fromPersonId: data.fromPersonId,
      toPersonId: data.toPersonId,
      movementType: data.movementType,
      movementDate: new Date(data.movementDate),
      description: data.description,
      equipmentId: data.equipmentId
    })
  }

  async getFromPersonList(search: string = '') {
    const data = await this.personService.getAllCompaniesPerson(search);
    this.fromPersonList = data.flatMap(company =>
      company.persons.map(person => ({
        id: person.id,
        fullName: `${person.name} ${person.lastName}`,
        companyName: company.companyName
      }))
    );
  }

  async getToPersonList(search: string = '') {
    const data = await this.personService.getAllCompaniesPerson(search);
    this.toPersonList = data.flatMap(company =>
      company.persons.map(person => ({
        id: person.id,
        fullName: `${person.name} ${person.lastName}`,
        companyName: company.companyName
      }))
    );
  }

  async onFromPersonSearch(term: any) {
    console.log('Teslim Eden arama:', term.term);
    await this.getFromPersonList(term.term);
  }

  async onToPersonSearch(term: any) {
    console.log('Teslim Alan arama:', term.term);
    await this.getToPersonList(term.term);
  }

  customSearchFn(term: string, item: any): boolean {
    term = term.toLocaleLowerCase('tr-TR');
    return (
      item.fullName.toLocaleLowerCase('tr-TR').includes(term) ||
      item.companyName.toLocaleLowerCase('tr-TR').includes(term)
    );
  }

  movementTypes = [
    { value: 1, label: 'Zimmetlendi' },
    //{ value: 2, label: 'Zimmet Alındı' },
    { value: 3, label: 'Servise Gönderildi' },
    { value: 4, label: 'Hurda / İade' },
    { value: 5, label: 'Arzalı' },
    { value: 6, label: 'Kayıp' },
  ];

  async setPersonDefaults(movementType: number) {
    if (!this.isPersonId) return;

    if (!this.assignmentMovement.get('fromPersonId')?.value && !this.assignmentMovement.get('toPersonId')?.value) {
      this.assignmentMovement.patchValue({
        fromPersonId: null,
        toPersonId: null
      });
    }

    const term = { term: _isUserNameAndLastName };
    switch (movementType) {
      case 1: // Zimmet Verildi
        //this.assignmentMovement.patchValue({ fromPersonId:  });
        this.assignmentMovement.patchValue({ toPersonId: this.isPersonId });
        break;
      case 2: // Zimmet Alındı
        this.assignmentMovement.patchValue({ fromPersonId: null });
        this.assignmentMovement.patchValue({ toPersonId: this.isPersonId });
        break;
      case 3: // Servise Gönderildi
        this.assignmentMovement.patchValue({ fromPersonId: this.isPersonId });
        this.assignmentMovement.patchValue({ toPersonId: null });
        break;
      case 4: // Hurda / İade
        this.assignmentMovement.patchValue({ fromPersonId: this.isPersonId });
        this.assignmentMovement.patchValue({ toPersonId: null });
        // case 5: // Hurda / İade
        //   this.assignmentMovement.patchValue({ fromPersonId: this.isPersonId });
        //   this.assignmentMovement.patchValue({ toPersonId: null });
        break;
      // case 5: // Kayıp
      //   this.assignmentMovement.patchValue({
      //     fromPersonId: null,
      //     toPersonId: null
      //   });
      //   // açıklamayı zorunlu yap
      //   this.assignmentMovement.get('description')?.setValidators([Validators.required]);
      //   this.assignmentMovement.get('description')?.updateValueAndValidity();

      //   // teslim eden / alan zorunluluğunu kaldır
      //   this.assignmentMovement.get('fromPersonId')?.clearValidators();
      //   this.assignmentMovement.get('fromPersonId')?.updateValueAndValidity();

      //   this.assignmentMovement.get('toPersonId')?.clearValidators();
      //   this.assignmentMovement.get('toPersonId')?.updateValueAndValidity();
      //   break;
      case 6: // Kayıp
        this.assignmentMovement.patchValue({
          fromPersonId: null,
          toPersonId: null
        });
        // açıklamayı zorunlu yap
        this.assignmentMovement.get('description')?.setValidators([Validators.required]);
        this.assignmentMovement.get('description')?.updateValueAndValidity();

        // teslim eden / alan zorunluluğunu kaldır
        this.assignmentMovement.get('fromPersonId')?.clearValidators();
        this.assignmentMovement.get('fromPersonId')?.updateValueAndValidity();

        this.assignmentMovement.get('toPersonId')?.clearValidators();
        this.assignmentMovement.get('toPersonId')?.updateValueAndValidity();
        break;
      default:
        // diğer durumlarda description zorunlu değil
        this.assignmentMovement.get('description')?.clearValidators();
        this.assignmentMovement.get('description')?.updateValueAndValidity();
        break;
    }
  }
  isSubmitting: boolean;
  async save() {
    if (this.assignmentMovement.invalid) {
      this.toastrService.error('Lütfen gerekli alanları doldurunuz.', 'Form Hatası');
      return;
    }
    this.isSubmitting = true; // butonu devre dışı bırak

    const formValue = this.assignmentMovement.value;

    let payload: any = {
      fromPersonId: formValue.fromPersonId,
      toPersonId: formValue.toPersonId,
      movementType: formValue.movementType,
      movementDate: Array.isArray(formValue.movementDate) ? formValue.movementDate[0] : new Date(formValue.movementDate).toISOString(),
      description: formValue.description,
      equipmentId: formValue.equipmentId,
      personId: this.isPersonId
    };

    console.log('Gönderilen veri:', payload);
    try {
      let data;
      if (this.data.id) {
        payload = { id: this.data.id, ...payload };
        data = await this.assignmetnService.updateAssignmentMovement(payload);
      } else {
        data = await this.assignmetnService.createAssignmentMovement(payload);
      }

      if (data.status) {
        this.toastrService.success(data.message);
        this.assignmetnService.sendEvent(true);
        this.equipmentService.sendEvent(true);
        this.activeModal.close(true);
      } else {
        this.toastrService.error(data.message);
      }
    } catch (error) {
      this.toastrService.error('Bir hata oluştu.');
    } finally {
      this.isSubmitting = false; // işlem bitince butonu yeniden aktif et
    }
  }
  closeModal() {
    this.activeModal.close(false);
  }
}